import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import Checkbox from '../../Common/Checkbox.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  updateForm,
  useSelector,
} from '../../../../store.js'
import {setShipper} from '../../../../data/shippers.js'
import {showGlobalError} from '../../../GlobalErrorMessage.js'
import apiverson from '../../../../common/apiverson.js'
import {AUSTRALIA_POST} from '../../../../common/constants/ShipperNames.js'
import {isPresent} from '../../../../common/utils.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import TextInput from '../../Common/TextInput.js'
import className from '../../../../common/className.js'
import {
  baseSaveParamsSelector,
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
} from '../ShippersFunctions.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  const errors = baseShipperFormErrorsSelector(state, {formName})
  const form = formSelector(state, {
    formName,
  })

  if (!isPresent(form.accountNumber)) {
    errors.accountNumber = 'Account number is required'
    errors.preventSave = true
  }

  if (!isPresent(form.apiKey)) {
    errors.apiKey = 'API Key is required'
    errors.preventSave = true
  }

  if (!isPresent(form.apiSecret)) {
    errors.apiSecret = 'API Secret is required'
    errors.preventSave = true
  }

  return errors
}

export function initialFormSelector(state, {shipper}) {
  const vendorConfig = shipper?.vendor_config || {}

  return {
    ...baseShipperInitialFormSelector(state, {shipper, vendor: AUSTRALIA_POST}),
    accountNumber: vendorConfig.account_number || '',
    apiKey: vendorConfig.api_key || '',
    apiSecret: vendorConfig.api_secret || '',
    printAsYouGo: vendorConfig.print_as_you_go || false,
  }
}

export async function saveShipperAustraliaPost(formName) {
  const form = formSelector(getState(), {formName})
  let [shipperID, params] = baseSaveParamsSelector(getState(), {formName})

  const {accountNumber, apiKey, apiSecret, printAsYouGo} = form

  params = {
    ...params,
    vendor_config: {
      account_number: accountNumber,
      api_key: apiKey,
      api_secret: apiSecret,
      print_as_you_go: printAsYouGo,
    },
  }

  updateForm(formName, {isSaving: true})

  try {
    const {json} =
      shipperID !== NEW_ID
        ? await apiverson.put(`/carrier/${shipperID}`, params)
        : await apiverson.post('/carrier/australia_post', {
            ...params,
            vendor: AUSTRALIA_POST,
          })

    goToShipperSettings()

    setShipper(json)
  } catch (err) {
    showGlobalError(
      {
        summary: 'There was an error while saving shipper.',
      },
      err,
    )

    updateForm(formName, {isSaving: false})
  }
}

function AustraliaPostForm({formName, form}) {
  const {id, accountNumber, apiKey, apiSecret, printAsYouGo, isSaving} = form
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap clear-both">
      <div className="medium-5 columns">
        <fieldset>
          <ul className="form-list margin-bottom-0">
            {id !== NEW_ID && <Nickname formName={formName} />}
            <li
              className={className`form-list-item bigger margin-bottom-20 ${{'margin-top-20 divider--top': id !== NEW_ID}}`}
            >
              <TextInput
                label="Account Number"
                name="account_number"
                value={accountNumber}
                onChange={(event) =>
                  updateForm(formName, {
                    accountNumber: event.target.value,
                    hasChanged_accountNumber: true,
                  })
                }
                errorMessage={
                  form.hasChanged_accountNumber && errors.accountNumber
                }
                required
              />
            </li>
            <li className="form-list-item bigger margin-bottom-20">
              <TextInput
                label="API Key"
                name="api_key"
                value={apiKey}
                onChange={(event) =>
                  updateForm(formName, {
                    apiKey: event.target.value,
                    hasChanged_apiKey: true,
                  })
                }
                errorMessage={form.hasChanged_apiKey && errors.apiKey}
                required
              />
            </li>
            <li className="form-list-item bigger margin-bottom-20">
              <TextInput
                label="API Secret"
                name="api_secret"
                type="password"
                value={apiSecret}
                onChange={(event) =>
                  updateForm(formName, {
                    apiSecret: event.target.value,
                    hasChanged_apiSecret: true,
                  })
                }
                errorMessage={form.hasChanged_apiSecret && errors.apiSecret}
                required
              />
            </li>
            <li className="form-list-item bigger margin-bottom-20">
              <Checkbox
                label="Print As You Go"
                id="print_as_you_go"
                checked={printAsYouGo}
                onChange={() =>
                  updateForm(formName, {printAsYouGo: !printAsYouGo})
                }
              />
            </li>
            {id !== NEW_ID && <ShippingMethods formName={formName} />}
            <li className="list__item list__item--no-style">
              <ButtonPrimary
                isLoading={isSaving}
                isDisabled={errors.preventSave}
                onClick={() => saveShipperAustraliaPost(formName)}
              >
                {id !== NEW_ID ? 'Save' : 'Create'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>

      {id !== NEW_ID && (
        <div className="medium-5 columns">
          <div className="alert margin-bottom-10 alert--standard">
            <Archive formName={formName} />
          </div>
        </div>
      )}
    </div>
  )
}

export default onlyIfAutoForm(AustraliaPostForm, setUpShipperForm)
